import { FiltersModel } from "./filters-models";

export class FilterTemplateResponseModel {
  templateId: number;
  isDefault: boolean;
  templateName: string;
  allLocations: boolean;
  allAssistTypes: boolean;
  allCategories: boolean;
  allDays: boolean;
  allServices: boolean;
  allRequestedStaff: boolean;
  allAssistedBy: boolean;
  allSupervisors: boolean;
  allStatuses: boolean;
  allUsers: boolean;
  activeFilters: FiltersModel;
  detailViewId: number;
  sharedUsers: string;
  sharedPermissionGroups: string;
  createdUserId?: number;

  constructor(source?: any) {
    if (source) {
      this.templateId = source.templateId;
      this.isDefault = source.isDefault;
      this.templateName = source.templateName;
      this.allLocations = source.allLocations;
      this.allAssistTypes = source.allAssistTypes;
      this.allCategories = source.allCategories;
      this.allDays = source.allDays;
      this.allServices = source.allServices;
      this.allRequestedStaff = source.allRequestedStaff;
      this.allAssistedBy = source.allAssistedBy;
      this.allSupervisors = source.allSupervisors;
      this.allStatuses = source.allStatuses;
      this.allUsers = source.allUsers;
      this.activeFilters = JSON.parse(JSON.stringify(source.activeFilters)); // deep clone
      this.detailViewId = source.detailViewId;
      this.sharedUsers = source.sharedUsers;
      this.sharedPermissionGroups = source.sharedPermissionGroups;
      this.createdUserId = source.createdUserId;
    } else {
      this.templateId = 0;
      this.isDefault = false;
      this.templateName = "";
      this.allLocations = false;
      this.allAssistTypes = false;
      this.allCategories = false;
      this.allDays = false;
      this.allServices = false;
      this.allRequestedStaff = false;
      this.allAssistedBy = false;
      this.allSupervisors = false;
      this.allStatuses = false;
      this.allUsers = false;
      this.detailViewId = 0;
      this.sharedUsers = "";
      this.sharedPermissionGroups = "";
      this.createdUserId = 0;
      this.activeFilters = <FiltersModel>{};
    }
  }
}
